import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, styled, tableCellClasses } from "@mui/material";
import { StockIndicator } from "../../components";
import { ArticleDB } from "../../data/db/db";
import { useTranslation } from "react-i18next";


interface ProductPriveAvailListProps {
    ident: string,
    articles: ArticleDB[],
    handleArticleClick: (ident: string, pos: string) => void,
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.mode === "light" ? "#e2e3e5" : "var(--ion-card-background)",
        fontWeight: "bold",
        padding: "0.5rem",
        borderBottom: theme.palette.mode === "light" && "1px solid #000",
        color: theme.palette.mode === "light" ? "#000" : "#dbdbdb"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: "0.5rem",
        color: theme.palette.mode === "light" ? "#000" : "#949494"
    },
}));

export function ProductPriveAvailList({ ident, articles, handleArticleClick }: ProductPriveAvailListProps) {
    const { t } = useTranslation();

    return (
        <div>
            <h2 className="tableTitle">{ident}</h2>
            <div className="tableContainer">
                {articles && articles.length > 0 ?

                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>{t("productPriceAvail.ArtNr")}</StyledTableCell>
                                    <StyledTableCell>{t("productPriceAvail.Preis")}</StyledTableCell>
                                    <StyledTableCell align="right">{t("productPriceAvail.Lager")}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {articles.map((article) => (
                                    <TableRow
                                        key={article.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell component="th" scope="row">
                                            <div style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(e) => {
                                                e.preventDefault();
                                                handleArticleClick(article.ident, article.pos)
                                            }}>
                                                {article.ident}-{article.pos}
                                            </div>

                                        </StyledTableCell>
                                        <StyledTableCell>{parseFloat(article.preis).toFixed(2)} €</StyledTableCell>
                                        <StyledTableCell align="right">
                                            <StockIndicator stock={article.bestand} />

                                        </StyledTableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    : <p>{t("productPriceAvail.notFound", { params: ident })}</p>}
            </div>
        </div>
    );
}